export const ExternalLink = ({ href, children, as }) => {
  const Component = as || 'a';
  return (
    <Component href={href} target="_blank" rel="noopener noreferrer">
      {children}
      &nbsp;
      {' '}
      <i className="fa fa-external-link" />
    </Component>
  );
};
